export const ERROR_TEXT = 'error'
export const BLANK_TEXT = ' '
export const BLANK_NUMBER = '0'
